import React from 'react';
import LayoutDashboard from '../../layout';
import { Switch, Route } from 'react-router-dom';
import { useRouter } from 'hooks/use-router';
import UserDetail from './pages/user-detail/user-detail';
import UserListPagination from "./pages/user-list/users";
import EkycIndividual from "../ekyc";

type TUsers = {};

const Users: React.FC<TUsers> = () => {
    const { match } = useRouter();

    return (
        <>
            <LayoutDashboard>
                <Switch>
                    <Route exact path={match.path}>
                        {/*<UserList />*/}
                        <UserListPagination />
                    </Route>
                    <Route path={`${match.path}/:id`}>
                        <UserDetail />
                    </Route>
                    <Route path={`${match.path}/:id/ekyc`}>
                        <EkycIndividual />
                    </Route>
                </Switch>
            </LayoutDashboard>
        </>
    );
};

export default Users;
